export default __webpack_public_path__ + "static/media/6.9262e085.svg";